<template>
    <div class="w-full flex flex-col pl-4">
        <field-row :fields="fieldValues"
                   :mode="mode"
                   :subject="'author'"
                   v-on:save="emitMessage('save', $event)"
                   v-on:cancel="emitMessage('cancel', $event)"
                   v-on:edit="emitMessage('edit', $event)"
                   v-on:delete="emitMessage('delete', $event)"
                   :errors="errors"
                   :template-string="':firstname :lastname (presenting: :is_presenting_author)'"
        ></field-row>
        <div v-if="author.id != null" class="w-full pl-4">
            <template v-if="author.affiliations && author.affiliations.length > 0">
                <div v-for="affiliation, index in author.affiliations" class="w-full flex items-center justify-between">
                    <div class="w-4/5 flex flex-row items-center">
                        <div v-if="author.affiliations.length > 1 && selectedAffiliationIndex === null" class="flex items-center justify-between" style="width: 3.5rem">
                            <button class="m-1 py-1 px-2 bg-gray-300"  v-if="index > 0" v-on:click="emitMessage('moveaffiliation', {author_id: author.id, id: affiliation.id, direction: -1})">↑</button>
                            <button class="m-1 py-1 px-2 bg-gray-300"  v-if="index < author.affiliations.length - 1" v-on:click="emitMessage('moveaffiliation', {author_id: author.id, id: affiliation.id, direction: 1})">↓</button>
                        </div>
                        <affiliation-row :affiliation="affiliation"
                                    :id="affiliation.id"
                                    :key="affiliation.id"
                                    :fields="affiliationfields"
                                    :affiliationfields="affiliationfields"
                                    v-on:edit="emitMessage('editaffiliation', index)"
                                    v-on:cancel="cancelAffiliationEditing"
                                    v-on:save="emitMessage('save', $event)"
                                    v-on:delete="emitMessage('delete', $event)"
                                    :errors="affiliationErrors"
                                    :mode="selectedAuthorIndex == authorIndex && selectedAffiliationIndex === index ? 'edit' : 'show'"
                        ></affiliation-row>

                    </div>
                    <div class="w-1/5 flex justify-end">
                        <div v-if="selectedAffiliationIndex != index"></div>
                        <div v-if="selectedAffiliationIndex == index"></div>
                        <button  v-if="showAddAffiliationButton(index)"
                                 class="p-1 bg-customindigo text-indigo-700"
                                 v-on:click="addAffiliation"
                                 v-html="translate('Add affiliation')"></button>

                    </div>
                </div>
            </template>
            <template v-else>
                <div class="w-full flex items-center">
                    <div class="w-4/5">
                    </div>
                    <div class="w-1/4 flex justify-end">
                        <button
                                class="p-1 bg-customindigo text-indigo-700"
                                v-on:click="addAffiliation"
                                v-html="translate('Add affiliation')"></button>
                    </div>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            selectedAuthorIndex: {},
            authorIndex: {},
            author: {type: Object},
            affiliationfields: {type: Array},
            fields: {type: Array},
            errors: {type: Object},
            affiliationErrors: {type: Object},
            mode: {type: String},
            id: {},
            selectedAffiliationIndex: {},
        },
        inject: ['translate'],
        data: function () {
            return {
                affiliations: [],
                authorInternal: {},
                fieldValues: [],
                affiliationMode: 'show'
            }
        },
        created: function() {
        },
        mounted() {
            this.authorInternal = {...this.author};
            this.fields.forEach((f) => {
                let fieldCopy = {...f}
                fieldCopy.value = this.authorInternal[f.field];
                this.fieldValues.push(fieldCopy);
            });

        },
        methods: {
            cancelAffiliationEditing: function() {
                this.$emit('cancelaffiliationedit');
            },

            emitMessage: function(message, payload) {
                if (payload.data) {
                    payload.data['author_id'] = this.author.id;
                }
                this.$emit(message, payload);
            },
            addAffiliation: function() {
                this.$emit('addaffiliation');
            },
            showAddAffiliationButton: function(index) {
                if ((!this.author['affiliations']) || (!this.author.affiliations[index]))  {
                    return false;
                }
                if (this.author.affiliations.length == 0) {
                    return true;
                }
                if (this.author.affiliations[index].id == null) {
                    return false;
                }
                return index == this.author.affiliations.length - 1;

            }
        },
        computed: {
        },
        watch: {
        }

    }
</script>
